import React, { useEffect, useState } from 'react';
import LeftArrow from '../../../asset/svg/leftArrow.svg';
import { useSnackbar } from 'notistack';
import { Document, Page, pdfjs } from 'react-pdf';
import CustomMessage from '../../../components/common/Snackbar/Snackbar';
import '../../../scss/pages/MyCertificates/Certificate/Certificate.scss';
import { useLocation, useNavigate } from 'react-router';
import { MY_CERTIFICATE_PATH } from '../../../utils/Constants';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function Certificate() {
    const navigate = useNavigate()
    const location = useLocation()
    const { PdfUrl, certificateNo, pageIndex } = location?.state;
    const [numPagess, setNumPages] = useState(1);
    const [downloadData, setDownloadData] = useState()
    const [disableBtn, setDisableBtn] = useState(true)
    const handleBack = () => {
        navigate(MY_CERTIFICATE_PATH, { state: { pageIndex: pageIndex } })
    }


    const navigatorShare = async (pdfBase64) => {
        if (navigator.share) {
            const data = [new File([downloadData], `Certificate_${certificateNo}.pdf`, { type: "application/pdf" })]
            navigator.share({
                files: data,
            })
                .then(() => console.log("Shared successfully"))
                .catch(error => console.error("Not shared:", error))
        } else if (AssetManager) {
            AssetManager.shareFile(pdfBase64, `Certificate_${certificateNo}`);
        } else {
            console.log("Certificate not Found");
        }
    }

    const handleDownloadQRData = async () => {
        // Download PDF
        if (downloadData) {
            const blob = new Blob([downloadData], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Certificate_${certificateNo}.pdf`;
        }

        if (downloadData) {
            //Base64
            const pdfBlob = new Blob([downloadData], { type: 'application/pdf' });
            const pdfArrayBuffer = await new Response(pdfBlob).arrayBuffer();
            const pdfBase64 = btoa(new Uint8Array(pdfArrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            navigatorShare(pdfBase64);
        }
    }


    const onDocumentLoadSuccess = (e) => {
        const { numPages } = e._pdfInfo;
        setNumPages(numPages)
        setDisableBtn(false)
    }
    const renderFile = (PdfUrl) => {
        return (
            <Document file={PdfUrl} onLoadSuccess={(e) => onDocumentLoadSuccess(e)} >
                {Array.from(new Array(numPagess), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
            </Document>
        )
    }

    useEffect(() => {
        fetch(PdfUrl)
            .then(response => response.blob())
            .then(async (data) => setDownloadData(data))
    }, []);

    return (
        <div className='Certificate-Modal-Container'>
            <div className='Certificate-Modal-Container_header'>
                <div>
                    <img className='Certificate-Modal-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='Certificate-Modal-Container_header_content'>Certificate</span>
                </div>
            </div>
            <div className='Certificate-Modal-Container_Document-image'>
                <div id='pdfcontainer' className='Certificate-Modal-Container_Document-image_child'>
                    {renderFile(PdfUrl)}
                </div>
            </div>
            <div className='Certificate-Modal-Container_Download-button'>
                <div className='Certificate-Modal-Container_Download-button_btn-bottom'>
                    <div className='Certificate-Modal-Container_Download-button_btn-bottom_okbutton-container'>
                        <button id='downloadBtn' disabled={disableBtn} className='Certificate-Modal-Container_Download-button_btn-bottom_okbutton-container_active-button' onClick={handleDownloadQRData} style={{ whiteSpace: "nowrap" }} >Download</button>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Certificate;